import React from 'react';
import clsx from 'clsx';

export const FieldWrapper = ({ label, className, error, children }) => {
  return (
    <div className={clsx('w-full', className)}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          {label}
        </label>
      )}

      <div>{children}</div>

      {error?.message && (
        <p className="mt-2 text-sm text-red-600 dark:text-red-400" role="alert">
          {error.message}
        </p>
      )}
    </div>
  );
};
